import {
  IconButton,
  type IconButtonProps,
  Tooltip,
  type TooltipProps,
} from '@mui/material';

interface UtilityIconButtonProps extends IconButtonProps {
  children: React.ReactNode;
  tooltip?: Omit<TooltipProps, 'children'>;
  size?: 'small' | 'medium' | 'large';
}
export const UtilityIconButton = ({
  children,
  tooltip,
  size = 'medium',
  ...props
}: UtilityIconButtonProps) => {
  const { sx, ...restProps } = props;

  const getSize = () => {
    switch (size) {
      case 'small':
        return 36;
      case 'large':
        return 56;
      default:
        return 44;
    }
  };

  const getBorderRadius = () => {
    switch (size) {
      case 'small':
        return 1.5;
      case 'large':
      default:
        return 2;
    }
  };

  const dimension = getSize();

  return (
    <Tooltip title="" {...tooltip}>
      <IconButton
        sx={{
          height: dimension,
          width: dimension,
          display: 'flex',
          alignItems: 'center',
          borderRadius: getBorderRadius(),
          bgcolor: 'action.hover',
          justifyContent: 'center',
          ...sx,
        }}
        {...restProps}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
};
